import { Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';

import { usePublicElevioArticle } from '../../../../hooks/elevio/usePublicElevioArticle';

import { parseElevioArticleId } from './parseElevioArticleId';
import styles from './styles.module.scss';

type Props = {
  className?: string;
  articleUrl: string;
};

export function LinkPreview({
  className,
  articleUrl,
}: Props): JSX.Element | null {
  const { data, isLoading } = usePublicElevioArticle({
    id: parseElevioArticleId(articleUrl),
  });

  if (isLoading || !data) {
    return null;
  }

  const linkPreviews = {
    headline: data.article?.title ?? '',
    description: data.article?.category.title ?? '',
  };

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={articleUrl}
      className={classNames(styles.linkPreviewContainer, className)}
    >
      <Text.Heading variant="heading-3" color="primary">
        {linkPreviews.headline}
      </Text.Heading>
      <Text.Paragraph variant="4" color="secondary">
        {linkPreviews.description}
      </Text.Paragraph>
    </a>
  );
}
